(function () {
  "use strict";

  /*
    SPARC CONFIGURATOR LOADING STATE
    Internal revision: V1.3

    Keep existing Shopify asset filenames:
      sparc-configurator-loading-v1.js
      sparc-configurator-loading-v1.css

    V1.3 POLISH PASS
    - No breadcrumb measurement or moving loader boundary
    - Stable full-page loading layer
    - SPARC site header stays above the loading layer
    - Breadcrumb + old navigation + original product layout remain hidden
      until the finished configurator is ready
    - Loader never changes position during startup
    - One clean fade/reveal
  */

  if (window.__SPARC_CONFIGURATOR_LOADING_V1_3__) return;
  window.__SPARC_CONFIGURATOR_LOADING_V1_3__ = true;

  /*
    EASY TUNING:
    Actual branded-loader visible time.
    1500 = 1.5 seconds.
  */
  var MIN_LOADER_VISIBLE_MS = 2500;

  var PANEL_IDS = [
    "sparc-muscle-configurator",
    "sparc-muscle-round-configurator",
    "sparc-driver-configurator",
    "sparc-heritage-configurator",
    "sparc-classic-3100-configurator",
    "sparc-classic-squarebody-configurator",
    "sparc-garage-configurator"
  ];

  var attempts = 0;
  var timer = null;
  var settleTimer = null;
  var revealed = false;
  var loaderShownAt = 0;

  function now() {
    return (
      window.performance &&
      typeof window.performance.now === "function"
        ? window.performance.now()
        : Date.now()
    );
  }

  function clearFailsafe() {
    if (window.__SPARC_CONFIG_LOADING_FAILSAFE__) {
      window.clearTimeout(
        window.__SPARC_CONFIG_LOADING_FAILSAFE__
      );

      window.__SPARC_CONFIG_LOADING_FAILSAFE__ = null;
    }
  }

  function activePanel() {
    for (var i = 0; i < PANEL_IDS.length; i++) {
      var panel =
        document.getElementById(
          PANEL_IDS[i]
        );

      if (!panel) continue;

      var rect =
        panel.getBoundingClientRect();

      var style =
        window.getComputedStyle(panel);

      if (
        rect.width > 0 &&
        rect.height > 0 &&
        style.display !== "none" &&
        style.visibility !== "hidden"
      ) {
        return panel;
      }
    }

    return null;
  }

  function buildLoader() {
    var existing =
      document.getElementById(
        "sparc-configurator-loader"
      );

    if (existing) {
      return existing;
    }

    var loader =
      document.createElement("div");

    loader.id =
      "sparc-configurator-loader";

    loader.className =
      "sparc-config-loader";

    loader.setAttribute(
      "role",
      "status"
    );

    loader.setAttribute(
      "aria-live",
      "polite"
    );

    loader.innerHTML =
      '<div class="sparc-config-loader__content">' +

        '<div class="sparc-config-loader__wheel" aria-hidden="true">' +
          '<div class="sparc-config-loader__wheel-ring"></div>' +
          '<div class="sparc-config-loader__wheel-sweep"></div>' +

          '<span class="sparc-config-loader__spoke sparc-config-loader__spoke--1"></span>' +
          '<span class="sparc-config-loader__spoke sparc-config-loader__spoke--2"></span>' +
          '<span class="sparc-config-loader__spoke sparc-config-loader__spoke--3"></span>' +

          '<span class="sparc-config-loader__hub"></span>' +
        '</div>' +

        '<div class="sparc-config-loader__brand">' +
          '<div class="sparc-config-loader__sparc">SPARC</div>' +
          '<div class="sparc-config-loader__industries">INDUSTRIES</div>' +
        '</div>' +

        '<div class="sparc-config-loader__status">' +
          'PREPARING CONFIGURATOR' +
        '</div>' +

        '<div class="sparc-config-loader__progress" aria-hidden="true">' +
          '<span></span>' +
        '</div>' +

      '</div>';

    document.body.appendChild(
      loader
    );

    loaderShownAt =
      now();

    return loader;
  }

  function removeLoader() {
    var loader =
      document.getElementById(
        "sparc-configurator-loader"
      );

    if (!loader) return;

    loader.classList.add(
      "is-leaving"
    );

    window.setTimeout(
      function () {
        if (
          loader &&
          loader.parentNode
        ) {
          loader.parentNode.removeChild(
            loader
          );
        }
      },
      320
    );
  }

  function performReveal(reason) {
    if (revealed) return;

    revealed = true;

    clearFailsafe();

    /*
      Mark reveal first. CSS keeps the final page under the white veil
      while the browser gets two frames to paint the completed layout.
    */
    document.documentElement.classList.add(
      "sparc-config-revealing"
    );

    window.requestAnimationFrame(
      function () {
        window.requestAnimationFrame(
          function () {

            /*
              The finished page already exists under the loader.
              Reveal it first, then fade only the white loader layer.
              This prevents any breadcrumb/navigation pop during fade.
            */
            document.documentElement.classList.remove(
              "sparc-config-loading"
            );

            document.documentElement.classList.add(
              "sparc-config-ready"
            );

            removeLoader();

            window.setTimeout(
              function () {
                document.documentElement.classList.remove(
                  "sparc-config-revealing"
                );
              },
              340
            );

            console.info(
              "[SPARC CONFIG LOADING V1.3] Page revealed.",
              reason || "configurator-ready"
            );
          }
        );
      }
    );
  }

  function revealWhenMinimumMet(reason) {
    if (revealed) return;

    var elapsed =
      loaderShownAt > 0
        ? now() - loaderShownAt
        : 0;

    var remaining =
      Math.max(
        0,
        MIN_LOADER_VISIBLE_MS -
        elapsed
      );

    window.setTimeout(
      function () {
        performReveal(
          reason
        );
      },
      remaining
    );
  }

  function check() {
    attempts += 1;

    var panel =
      activePanel();

    if (!panel) {
      if (attempts >= 120) {
        window.clearInterval(
          timer
        );

        timer = null;

        revealWhenMinimumMet(
          "poll-timeout"
        );
      }

      return;
    }

    window.clearInterval(
      timer
    );

    timer = null;

    /*
      Small settle period after the panel exists so breadcrumb replacement,
      shared series navigation, lead-time bridge, Hulk conditions, and hero
      layout finish before the white veil disappears.
    */
    window.clearTimeout(
      settleTimer
    );

    settleTimer =
      window.setTimeout(
        function () {
          revealWhenMinimumMet({
            panel: panel.id
          });
        },
        220
      );
  }

  function start() {
    if (
      !document.documentElement.classList.contains(
        "sparc-config-loading"
      )
    ) {
      return;
    }

    buildLoader();

    timer =
      window.setInterval(
        check,
        50
      );

    check();

    window.addEventListener(
      "load",
      function () {
        if (
          document.documentElement.classList.contains(
            "sparc-config-loading"
          )
        ) {
          check();
        }
      },
      {
        once: true
      }
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
